import { ENGT_CHAT } from 'js/bot.model';

export let headerOptions = {
	exitHeader: ENGT_CHAT.get('GENERIC_STRINGS')?.CLOSE_CHAT_PROMPT || 'Are you sure you want to close the chat?',
	close: ENGT_CHAT.get('GENERIC_STRINGS')?.CLOSE_CHAT || 'Close Chat',
	startNew: ENGT_CHAT.get('GENERIC_STRINGS')?.START_NEW_CONVERSATION || 'Start a new conversation',
	continueChat: ENGT_CHAT.get('GENERIC_STRINGS')?.CONTINUE_CONVERSATION || 'Continue ongoing conversation',
	exitConversation: ENGT_CHAT.get('GENERIC_STRINGS')?.EXIT_AGENT_CONVERSATION || 'Exit Agent Conversation',
	closeModal: {},
};

export const setter = (props) => {
	headerOptions = {
		...headerOptions,
		...props,
	};
};
